import React, {useContext} from "react";
import {CustomCard} from "../common/index";
import {ContentContext} from "../../ContentContext";
import {getDirectusImage} from "../../api/directus";

function Services() {
    const data = useContext(ContentContext);

    if (!data?.showSections.includes("services")) {
        return null;
    }

    const services = data?.services?.map((item) => ({
        ...item,
        imagePath: getDirectusImage(item?.image),
    }));

    return (
        <section className={"services"}>
            <h2>{data.servicesTitle}</h2>
            <span className={"services-description"} dangerouslySetInnerHTML={{__html: data?.servicesDescription}} />
            <div className={"services-list"}>
                <CustomCard items={services} variant={"default"} />
            </div>
        </section>
    );
}

export default Services;
